import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { dashboardService, connectionService, noticeService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as dashboardActions from './actions';

export function getDashboardConnections(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_CONNECTIONS),
    mergeMap(({ payload }) => {
      return connectionService.getConnections(payload)
        .pipe(
          map(res => dashboardActions.getDashboardConnectionsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchDashboardNotices(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_NOTICES),
    mergeMap(({ payload }) => {
      return noticeService.getNotices(payload)
        .pipe(
          map(res => dashboardActions.fetchDashboardNoticesSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function getDashboardReadPosts(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_READ_POSTS),
    mergeMap(({ payload }) => {
      return dashboardService.getReadposts(payload)
        .pipe(
          map(res => dashboardActions.getDashboardReadPostsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
// export function getEmergencyBroadcastMessage(action$) {
//   return action$.pipe(
//     ofType(actionTypes.GET_EMERGENCY_BROADCAST_MESSAGE),
//     mergeMap(({ payload }) => {
//       return emergencybrodcastService.getEmergencybroadcasts(payload)
//         .pipe(
//           map(res => dashboardActions.getEmergencyBroadcastMessageSuccess(res.responceObject.records)),
//           catchError(error => {
//             console.log(error)
//           })
//         )
//     })
//   )
// }